var map = {
	"./CircularStd-Bold.woff": 41781,
	"./CircularStd-BoldItalic.woff": 78198,
	"./CircularStd-Book.woff": 55470,
	"./CircularStd-BookItalic.woff": 40567,
	"./CircularStd-Medium.woff": 45419,
	"./CircularStd-MediumItalic.woff": 70048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87673;